import { render, staticRenderFns } from "./crossed-out.vue?vue&type=template&id=5f590402&"
import script from "./crossed-out.vue?vue&type=script&lang=js&"
export * from "./crossed-out.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports